import { render, staticRenderFns } from "./ReasonModal.vue?vue&type=template&id=72b5e8fc&scoped=true"
import script from "./ReasonModal.vue?vue&type=script&lang=js"
export * from "./ReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b5e8fc",
  null
  
)

export default component.exports